<template>
  <div :class="[colClass, props.class]">
    <slot></slot>
  </div>
</template>
  
  <script setup>
  import { computed } from 'vue';
  
  const props = defineProps({
    cols: {
      type: String,
      default: ''
    }, 
    class: {
      type: String,
      default: ''
    }
  });
  
  const colClass = computed(() => {
    return props.cols ? `col-${props.cols}` : 'col';
  });
  </script>